"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Categories = void 0;
var react_1 = __importDefault(require("react"));
var useLoadCategories_1 = require("../../hook/useLoadCategories");
var CategoryManager_1 = require("./CategoryManager");
var tabs_1 = __importDefault(require("antd/es/tabs"));
var typography_1 = __importDefault(require("antd/es/typography"));
var Title = typography_1.default.Title;
var Categories = function () {
    var _a = (0, useLoadCategories_1.useLoadCategories)(), brands = _a.brands, models = _a.models, generations = _a.generations, colors = _a.colors, bodyTypes = _a.bodyTypes, enginePowerTypes = _a.enginePowerTypes, engineNameTypes = _a.engineNameTypes, engineCapacityTypes = _a.engineCapacityTypes, gearboxTypes = _a.gearboxTypes, driveTypes = _a.driveTypes, extras = _a.extras, categories = _a.categories, refreshData = _a.refreshData;
    if (!brands.length)
        return react_1.default.createElement("div", { style: { marginTop: '50px', textAlign: 'center' } }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
    return (react_1.default.createElement("div", { style: { padding: '20px' } },
        react_1.default.createElement(Title, { level: 1 }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0439"),
        react_1.default.createElement(tabs_1.default, { items: [
                {
                    key: 'brands',
                    label: 'Бренды',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: brands, dataKey: "brand", endpoint: "brands", title: "\u0411\u0440\u0435\u043D\u0434", onUpdate: refreshData })),
                },
                {
                    key: 'colors',
                    label: 'Цвета',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: colors, endpoint: "colors", dataKey: "color", title: "\u0426\u0432\u0435\u0442", onUpdate: refreshData })),
                },
                {
                    key: 'models',
                    label: 'Модели',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: models, endpoint: "models", title: "\u041C\u043E\u0434\u0435\u043B\u044C", onUpdate: refreshData, dataKey: "model", brands: brands })),
                },
                {
                    key: 'generations',
                    label: 'Поколения',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: generations, endpoint: "generations", title: "\u041F\u043E\u043A\u043E\u043B\u0435\u043D\u0438\u0435", onUpdate: refreshData, models: models, dataKey: "generation" })),
                },
                {
                    key: 'body_types',
                    label: 'Типы кузова',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: bodyTypes, endpoint: "body_types", title: "\u0422\u0438\u043F \u043A\u0443\u0437\u043E\u0432\u0430", onUpdate: refreshData, dataKey: "body_type" })),
                },
                {
                    key: 'engine_power_types',
                    label: 'Типы мощности',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: enginePowerTypes, endpoint: "engine_power_types", title: "\u0422\u0438\u043F \u043C\u043E\u0449\u043D\u043E\u0441\u0442\u0438", onUpdate: refreshData, dataKey: "engine_power_type" })),
                },
                {
                    key: 'engine_name_types',
                    label: 'Типы двигателей',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: engineNameTypes, endpoint: "engine_name_types", title: "\u0422\u0438\u043F \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", onUpdate: refreshData, dataKey: "engine_name_type" })),
                },
                {
                    key: 'engine_capacity_types',
                    label: 'Типы объема двигателя',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: engineCapacityTypes, endpoint: "engine_capacity_types", title: "\u0422\u0438\u043F \u043E\u0431\u044A\u0435\u043C\u0430 \u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044F", onUpdate: refreshData, dataKey: "engine_capacity_type" })),
                },
                {
                    key: 'gearbox_types',
                    label: 'Типы коробок передач',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: gearboxTypes, endpoint: "gearbox_types", title: "\u0422\u0438\u043F \u043A\u043E\u0440\u043E\u0431\u043A\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447", onUpdate: refreshData, dataKey: "gearbox_type" })),
                },
                {
                    key: 'drive_types',
                    label: 'Типы приводов',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: driveTypes, endpoint: "drive_types", title: "\u0422\u0438\u043F \u043F\u0440\u0438\u0432\u043E\u0434\u0430", onUpdate: refreshData, dataKey: "drive_type" })),
                },
                {
                    key: 'categories',
                    label: 'Категории дополнительного оборудования',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: categories, endpoint: "categories", title: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435", onUpdate: refreshData, dataKey: "category" })),
                },
                {
                    key: 'extras',
                    label: 'Названия дополнительного оборудования',
                    children: (react_1.default.createElement(CategoryManager_1.CategoryManager, { items: extras, endpoint: "extra_names", title: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435", onUpdate: refreshData, dataKey: "extra_name" })),
                },
            ] })));
};
exports.Categories = Categories;
